module.exports = __webpack_public_path__ + "static/media/filter_6_white_18dp.4c595d8a.svg";